import { useLayoutEffect, useRef } from "react";

import { type Location, useLocation } from "react-router";

type LocationChangeCallback = (
  location: Location,
  prevLocation: Location | null,
) => void;

/**
 * Run a function when the route changes.
 */
export function useLocationChange(fn: LocationChangeCallback): void {
  const location = useLocation();
  const prevLocationRef = useRef<Location | null>(null);

  useLayoutEffect(() => {
    fn(location, prevLocationRef.current);
    prevLocationRef.current = location;
  }, [location, fn]);
}
